module.exports = __webpack_public_path__ + "img/groupGameBtn.d5453f40.png";